import React, { ReactNode } from 'react';
import { Result, Skeleton, Typography, Space } from 'antd';
import { WarningOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button } from '@bancobarigui/barihaus';
import { ServiceName } from '@/contexts/service-status.context';

const { Text } = Typography;

const SERVICE_NAMES: Record<ServiceName, string> = {
  auth: 'Autenticacao',
  user: 'Usuarios',
  registration: 'Cadastros',
  inspection: 'Inspecoes',
  checklist: 'Checklists',
  notification: 'Notificacoes',
  scraper: 'Busca de Imoveis',
};

interface ServiceUnavailableProps {
  services: ServiceName[];
  featureName?: string;
  onRetry?: () => void;
  showSkeleton?: boolean;
  skeletonRows?: number;
  skeleton?: ReactNode;
}

export function ServiceUnavailable({
  services,
  featureName,
  onRetry,
  showSkeleton = false,
  skeletonRows = 3,
  skeleton,
}: ServiceUnavailableProps): JSX.Element {
  const serviceNames = services.map(s => SERVICE_NAMES[s]).join(', ');

  return (
    <div style={{ padding: '24px' }}>
      <Result
        icon={<WarningOutlined style={{ color: '#faad14' }} />}
        title={featureName ? `${featureName} indisponivel` : 'Funcionalidade indisponivel'}
        subTitle={
          <Space direction="vertical" size="small">
            <Text type="secondary">
              {services.length === 1
                ? `O servico de ${serviceNames} esta temporariamente offline.`
                : `Os servicos de ${serviceNames} estao temporariamente offline.`}
            </Text>
            <Text type="secondary">Tente novamente em alguns instantes.</Text>
          </Space>
        }
        extra={
          onRetry && (
            <Button buttonColor="primary" icon={<ReloadOutlined />} onClick={onRetry}>
              Tentar novamente
            </Button>
          )
        }
      />
      {showSkeleton && (
        <div style={{ marginTop: '24px' }}>
          {skeleton || <Skeleton active paragraph={{ rows: skeletonRows }} />}
        </div>
      )}
    </div>
  );
}

export default ServiceUnavailable;
